var file_upload_viewer_default = {
  "fontElementMap": "Prpqn",
  "file_upload_container": "_0-nso",
  "file_upload_link": "b9YrT",
  "file_upload_error_container": "-VEbY",
  "file_upload_file_info": "vhhhO",
  "file_upload_type_icon": "rAs0H",
  "file_upload_status_icon_container": "X80fI",
  "file_upload_status_icon": "uCT9t",
  "file_upload_description": "-B8aB",
  "file_upload_name_container": "zu4Z7",
  "file_upload_name": "ixq2T",
  "file_upload_extension": "ibF4q",
  "file_loader_icon": "UiZVd",
  "file_upload_icon_frame": "Ni0fS",
  "file_upload_icon_background": "o-1X5"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
